import type { EventExtra } from '@cocoonspace/sdk-js/types/eventExtra'
import type { Extra } from '@cocoonspace/sdk-js/types/extra'
import { useMemo } from 'react'
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@cocoonspace/ui/components/tabs'
import { useLingui } from '@lingui/react/macro'
import { parseAsString, useQueryState } from 'nuqs'

import { MainContainer } from '~/components/atoms/main-container'
import { SectionHeader } from '~/components/atoms/section-header'
import { ExtraDetails } from '../extra-details/extra-details'

export const ExtrasPage = ({ extras }: { extras: Extra[] }) => {
	const { t } = useLingui()

	const tabs = useMemo(() => {
		if (!extras.length) return []

		return extras
			?.filter((extra) => extra.sub_category)
			?.reduce((acc, extra) => {
				if (extra.sub_category && !acc.includes(extra.sub_category)) {
					acc.push(extra.sub_category)
				}

				return acc
			}, [] as string[])
	}, [extras])

	const [activeTab, setActiveTab] = useQueryState(
		'extraCategory',
		parseAsString.withDefault(tabs[0]),
	)

	return (
		<MainContainer className='py-0 lg:py-4'>
			<SectionHeader
				title={t`La carte des Extras`}
				subtitle={t`Cocoon Space s'est entouré de prestataires de choix pour organiser vos repas et/ou pauses gourmandes sans que vous ayez à lever le petit doigt.`}
			/>

			<Tabs
				onValueChange={setActiveTab}
				value={activeTab}
			>
				<TabsList className='mb-4 self-start'>
					{tabs.map((tab) => (
						<TabsTrigger
							key={tab}
							value={tab}
						>
							{tab === 'breakfast' && t`Petit déjeuner`}
							{tab === 'lunch_delivery' && t`Déjeuner`}
							{tab === 'lunch_restaurant' && t`Brasserie`}
							{tab === 'snacks' && t`Goûter`}
							{tab === 'study_day' && t`Journée d'étude`}
							{tab === 'after_work' && t`Afterwork`}
						</TabsTrigger>
					))}
				</TabsList>

				{tabs.map((tab) => (
					<TabsContent
						className='m-0 grid grid-cols-1 gap-6 md:grid-cols-2'
						key={tab}
						value={tab}
					>
						{extras
							.filter((extra) => extra.sub_category === tab)
							.map((extra) => (
								<ExtraDetails
									key={extra.id}
									action={null}
									extra={
										{
											...extra,
											choices: undefined,
											quantity: 0,
											unit_price: extra.price,
										} as unknown as EventExtra
									}
								/>
							))}
					</TabsContent>
				))}
			</Tabs>
		</MainContainer>
	)
}
